import React from 'react';
import { ToriutLogo } from '@picsio/icons';
import picsioConfig from '../../../../../config';
import Button from './Button';

/**
 * Logo
 * @param {Object} props
 * @param {string} props.src
 * @param {string} props.username
 * @param {number} props.size
 * @param {boolean} props.avatarPicsio
 * @param {string} props.className
 * @returns {JSX}
 */
export default function Logo({ handleLogoClick, additionalClass }) {
  if (picsioConfig.isPim) {
    return (
      <Button
        id="button-logo"
        additionalClass={additionalClass}
        onClick={handleLogoClick}
        iconSize="xxl"
        icon={() => <ToriutLogo />}
      />
    );
  }

  return <Button id="button-logo" icon="logoPicsio" additionalClass={additionalClass} onClick={handleLogoClick} />;
}
